export const stateName = 'session' as const
